import { ActionIcon } from "@mantine/core";
import { IconHelp } from "@tabler/icons-react";
import urls from "../../urls";

const HELP_LINK = {
  text: "opti.node-Hilfe",
  href: urls.optiSupport()
};

function OptiNodeHelpIcon() {
  return (
    <ActionIcon
      aria-label={HELP_LINK.text}
      className="OptiNodeHelpIcon"
      color="neutral.8"
      component="a"
      href={HELP_LINK.href}
      rel="noopener noreferrer"
      target="_blank"
      title={HELP_LINK.text}
      variant="transparent"
      visibleFrom="md"
    >
      <IconHelp />
    </ActionIcon>
  );
}

export { OptiNodeHelpIcon };
